import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  /** Compact variant for widgets / table bodies. */
  compact?: boolean;
  className?: string;
}

export function EmptyState({ icon, title, description, action, compact, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center', compact ? 'gap-2 px-4 py-8' : 'gap-3 px-6 py-16', className)}>
      <div
        className={cn(
          'flex items-center justify-center rounded-xl border border-border bg-muted/60 text-muted-foreground',
          compact ? 'size-9 [&_svg]:size-4' : 'size-12 [&_svg]:size-5',
        )}
      >
        {icon ?? <Inbox />}
      </div>
      <div className="max-w-sm space-y-1">
        <p className={cn('font-semibold text-foreground', compact ? 'text-[13px]' : 'text-sm')}>{title}</p>
        {description && <p className="text-[13px] text-muted-foreground">{description}</p>}
      </div>
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
